export default __webpack_public_path__ + "static/media/smallCheckMark.1d070816.svg";